import Vue from 'vue'
import Vuex from 'vuex'

import Notification from './notification'
import Session from './session'
import Invoice from './invoice'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    Notification,
    Session,
    Invoice,
  },
  state: {
    userBalance: 0,
    currentUser: {},
    verifyUserFIscalData: '',
    demoApiUrl: 'https://demoapi.hydraship.com/api/v1',
    userFilters: {
      search: '',
      field: 'email',
      status: '',
      special_carriers: '',
      user_price: ''
    },
    carrierIndexTab: 0
  }
})

export default store
